import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "7f6b9cb6-e796-43e9-acab-0f1e7b0457dc", content: "The same.", options: {} },
  { id: "4b51d0ed-eb4e-43fa-864c-01351c25750e", content: "Increased at all frequencies.", options: {} },
  { id: "72021d7d-8a91-4faa-b8de-5b370fc79971", content: "Decreased at all frequencies.", options: {} },
  { id: "6b981a8e-b2ad-4434-8890-a3b3f3dd407e", content: "Increased at coincidence frequency.", options: {} },
  {
    id: "a7ddbc4e-cfce-46c7-a93d-0501ee73ac42",
    content: "The standardized impact sound pressure level does not  dependent on the absorption in receiving room",
    options: {},
  },
];

export const task: Task = {
  id: "35de6f33-e4e3-4f7e-ac92-3c64a89b999d",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["4b51d0ed-eb4e-43fa-864c-01351c25750e"],
};
